<script lang="ts">
  export let variant: 'primary' | 'secondary' | 'ghost' = 'primary';
  export let disabled: boolean = false;
  export let loading: boolean = false;
  export let type: 'button' | 'submit' | 'reset' = 'button';

  $: isDisabled = disabled || loading;
</script>

<button
  {type}
  class="btn btn--{variant}"
  class:btn--loading={loading}
  disabled={isDisabled}
  on:click
>
  {#if loading}
    <span class="btn__spinner" aria-hidden="true">...</span>
  {/if}
  <slot />
</button>

<style>
  .btn {
    display: inline-flex;
    align-items: center;
    gap: var(--ptt-space-2);
    padding: var(--ptt-space-2) var(--ptt-space-5);
    font-family: var(--ptt-font-sans);
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    border-radius: var(--ptt-radius-sm);
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    white-space: nowrap;
  }

  .btn:focus-visible {
    outline: none;
    box-shadow: var(--ptt-focus-ring);
  }

  /* Primary */
  .btn--primary {
    background: var(--ptt-yellow-100);
    color: var(--ptt-black);
    border: none;
  }

  .btn--primary:hover:not(:disabled) {
    background: var(--ptt-yellow-200);
  }

  /* Secondary */
  .btn--secondary {
    background: transparent;
    color: var(--ptt-purple-100);
    border: 2px solid var(--ptt-purple-100);
  }

  .btn--secondary:hover:not(:disabled) {
    background: var(--ptt-gray-10);
  }

  /* Ghost */
  .btn--ghost {
    background: transparent;
    color: var(--ptt-gray-300);
    border: none;
  }

  .btn--ghost:hover:not(:disabled) {
    background: var(--ptt-gray-10);
  }

  /* Disabled */
  .btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Loading spinner */
  .btn__spinner {
    font-weight: 400;
    letter-spacing: 0.05em;
  }
</style>
